import { PageHeader } from "@sylviq/ui-react-web/components/ui/page-header";
import { Tabs } from "@sylviq/ui-react-web/components/ui/tabs";
import { useViewSearch } from "@/lib/view-search";
import { FiscalYearsSettings } from "./FiscalYearsSettings";
import { PeriodLocksSettings } from "./PeriodLocksSettings";

const SECTIONS = [
  { value: "period-locks", label: "Period locks" },
  { value: "fiscal-years", label: "Fiscal years" },
];

export function BooksSettingsPage({ embedded = false }: { embedded?: boolean } = {}) {
  const [section, setSection] = useViewSearch(
    "section",
    SECTIONS.map((item) => item.value),
    "period-locks",
  );
  return (
    <div className="grid gap-6">
      {embedded ? null : (
        <PageHeader
          title="Books"
          description="Period locks and fiscal years for the open books."
        />
      )}
      <Tabs
        tabs={SECTIONS}
        value={section}
        onValueChange={setSection}
        label="Books settings sections"
      >
        {section === "fiscal-years" ? (
          <FiscalYearsSettings />
        ) : (
          <PeriodLocksSettings />
        )}
      </Tabs>
    </div>
  );
}
